'use client';
import clsx from 'clsx';
import Image from 'next/image';
import React, { useState } from 'react';

import useClientTranslation from '@/components/hooks/useClientTranslation';

import ButtonBet from '@/app/[lng]/(general)/game/[slug]/components/PC/ButtonBet';
import StrokeBet from '@/app/[lng]/(general)/game/[slug]/components/PC/StrokeBet';
import { PARTNER_PROVIDER } from '@/constant/data';

const ItemEsportPc = (props: any) => {
  const { data, isButton = true, onClick, currentPage } = props || {};
  const [loaded, setLoaded] = useState(false);
  const { t } = useClientTranslation('HomePage');
  const sportTv = currentPage === PARTNER_PROVIDER.sportv;
  const sbo = currentPage === PARTNER_PROVIDER.sbo;
  const esport = currentPage === PARTNER_PROVIDER.esport;
  return (
    <div
      onClick={() => onClick(data)}
      key={data.key}
      className='flex flex-col items-center transition-all'
    >
      <div
        className={clsx('shine-item cursor-hand py-3', !loaded && 'loading-bg')}
      >
        <div className='relative'>
          <div className='hover:!brightness-50'>
            <Image
              src={data?.imgPC}
              width={229}
              height={260}
              alt='banner'
              className={clsx(
                'cursor-hand',
                data.partner_provider === PARTNER_PROVIDER.sportv &&
                  sportTv &&
                  'brightness-50',
                data.partner_provider === PARTNER_PROVIDER.sbo &&
                  sbo &&
                  'brightness-50',
                data.partner_provider === PARTNER_PROVIDER.esport &&
                  esport &&
                  'brightness-50'
              )}
              onLoad={() => {
                setLoaded(true);
              }}
            />
          </div>
          <div className='absolute bottom-0 left-0 right-0 top-0'>
            <StrokeBet color={data.colorBtn} />
          </div>
        </div>
      </div>
      {isButton && <ButtonBet color={data.colorBtn} t={t} />}
    </div>
  );
};

export default ItemEsportPc;
